import React from 'react';
import { useMediaQuery } from '@mui/material';
import { DesktopTaxBrackets } from './DesktopTaxBrackets';
import { MobileTaxBrackets } from './MobileTaxBrackets';

export const TaxBracketView = (props) => {
    const isMobile = useMediaQuery((theme) => theme.breakpoints.down('md'));
    
    return isMobile ? (
      <MobileTaxBrackets {...props} />
    ) : (
      <DesktopTaxBrackets {...props} />
    );
  };